<template>
  <div class="row align-items-center">
    <div class="" v-for="(post, index) in posts" :key="index">
      <div
        class="card-row"
        :style="homeBanner"
        v-if="index == indexBanner || index == 6"
      >
        <div class="col-12">
          <a :href="bannerArroba.url">
            <img :src="bannerArroba.image" :alt="bannerArroba.url" />
          </a>
        </div>
      </div>
      <div class="card-row" v-else>
        <div class="col-5" :style="backColor">
          <img
            width="157"
            height="133"
            :src="`${post.cover}`"
            :alt="post.title"
          />
        </div>
        <div class="col-7" :style="backColor">
          <NuxtLink
            :to="{
              name: 'language-colunas-catergoriaId-categoriaName-colunaId-colunaName',
              params: {
                language: route.params.language,
                catergoriaId: post.tag_id,
                categoriaName: post.slugCategory,
                colunaId: post.id,
                colunaName: post.slug,
              },
            }"
            class="button--more"
          >
            <p>
              <NuxtLink
                :to="{
                  name: 'language-colunas-catergoriaId-categoriaName',
                  params: {
                    language: route.params.language,
                    catergoriaId: post.tag_id,
                    categoriaName: post.slugCategory,
                  },
                }"
                >
                <span class="card-category">{{ post.category }}</span>
              </NuxtLink>
            </p>
            <div class="card-title">{{ post.title }}</div>
            <p></p>
            <p
              class="card-text"
              v-for="description in post.meta_description"
              :key="description.language_id"
            >
              <span
                v-if="
                  description.language_id === 1 &&
                  route.params.language === 'pt-br'
                "
                v-text="description.content"
              ></span>
              <span
                v-if="
                  description.language_id === 2 &&
                  route.params.language === 'en'
                "
                v-text="description.content"
              ></span>
            </p>
          </NuxtLink>
        </div>
      </div>
      <hr
        style="background-color: black"
        :style="index == 1 && route.name == 'language' ? homeBanner : ''"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import api from "@/api";
defineProps(["posts"]);
const indexBanner = ref(2);
const homeBanner = ref({ display: "block" });
const backColor = ref({ backgroundColor: "#f6f8fb" });
const route = useRoute();
const bannerArroba = ref({ image: "", url: "" });
const getBannerArroba = async () => {
  await api
    .get(`v1/home/getBannerArroba?language=${route.params.language ?? ""}`)
    .then(({ data }) => {
        bannerArroba.value = data.bannerArroba;
    })
    .catch((error) => {
      console.log(error);
    });
};

onMounted(() => {
  if (route.name == "language") {
    homeBanner.value = { display: "none" };
    backColor.value = { backgroundColor: "#f6f8fb" };
  } else {
    backColor.value = { backgroundColor: "#FFFFFF" };    
  }
  getBannerArroba();
});
</script>
<style scoped>
.card-title {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 21px;
  padding: 0 10px;
}

.card-text {
  color: #5b5858;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  padding: 0 10px;
}

.card-text span {
  font-family: "Roboto-Regular";
}

.button--more svg {
  color: #b20000;
}

.button--more {
  font-family: "Exo-2";
  font-weight: bold;
}

.small svg {
  margin-right: 5px;
}

.card-row img {
  width: 100%;
  object-fit: cover;
  height: auto;
}
.card-row {
  background-color: var(--bs-white);
  width: 100%;
  display: flex;
}
.card-category {
  background-color: black;
  padding: 5px 15px;
  font-size: 11px;
  border-radius: 20px;
  width: fit-content;
  margin-left: 10px;
  color: white;
}
</style>
